import React from 'react'
import NavbarSite from '../layout/header/Navbar'
import Sidebar from './SideBar'

function DashboardLayout({children, activeMenu}) {
  return (
      <div>
        <NavbarSite />
        <Sidebar activeMenu={activeMenu}  children={children}/>
      </div>    
  )
}

export default React.memo(DashboardLayout);
